import { type SVGProps, useMemo } from 'react';

interface IOn3RecruitProps extends SVGProps<SVGSVGElement> {
  isAlt?: boolean;
  fillAlt?: string;
}

export const On3Recruit = ({
  fill,
  isAlt,
  fillAlt,
  ...props
}: IOn3RecruitProps) => {
  const fills = useMemo(() => {
    if (isAlt) {
      return {
        r: fillAlt || '#0d8bff',
        l: fill || '#6f747b',
      };
    }

    return {
      r: fill ?? 'currentColor',
      l: fill ?? 'currentColor',
    };
  }, [fill, isAlt, fillAlt]);

  return (
    <svg
      fill="none"
      height="15"
      viewBox="0 0 94 15"
      width="94"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M86.9523 14.4997C82.6884 14.4997 80.9061 13.3414 81.3348 11.0995H85.8017C85.6889 11.7721 86.1627 12.071 87.3358 12.071C88.2382 12.071 88.6894 11.8842 88.7797 11.5479C88.8699 11.1929 88.6669 10.9314 87.9449 10.838L85.734 10.5764C83.2073 10.2775 81.9665 9.13789 82.4628 7.19493C82.8914 5.4388 84.8316 4.31787 88.7797 4.31787C93.0887 4.31787 94.2844 5.88718 93.946 7.66199H89.7498C89.84 7.02679 89.5241 6.72788 88.4187 6.72788C87.4486 6.72788 87.02 6.89602 86.9297 7.26966C86.8395 7.62463 87.1102 7.81145 87.7645 7.88618L89.9754 8.14773C92.8405 8.48401 93.8106 9.67967 93.3594 11.5105C92.9082 13.3601 90.8326 14.4997 86.9523 14.4997Z"
        fill={fills.l}
      />
      <path
        d="M78.7956 7.07077L78.0001 10.2938C77.841 10.9816 78.341 11.3746 78.932 11.3746H79.9547L79.2047 14.4011C78.5683 14.4601 78.1365 14.4994 77.4092 14.4994C74.0229 14.4994 72.5683 13.163 73.2501 10.3527L74.0683 7.07077H72.3638L73.0456 4.26047H74.7501L75.5229 1.13574H80.2501L79.4774 4.26047H81.9092L81.2274 7.07077H78.7956Z"
        fill={fills.l}
      />
      <path
        d="M67.2523 3.55882L67.9523 0.5H72.3644L71.6644 3.55882H67.2523ZM64.728 14.5L67.0614 4.38235H71.4735L69.1401 14.5H64.728Z"
        fill={fills.l}
      />
      <path
        d="M60.6269 4.31787H65.3638L62.8587 14.2683H58.2129L58.5773 12.822H58.509C57.5981 13.8826 56.4139 14.4997 54.7514 14.4997C52.4058 14.4997 50.7433 13.227 51.5859 9.89087L52.9979 4.31787H57.7347L56.3683 9.77517C56.1178 10.7586 56.6416 11.1443 57.5298 11.1443C58.3268 11.1443 58.9189 10.8358 59.1922 10.0451L60.6269 4.31787Z"
        fill={fills.l}
      />
      <path
        d="M51.0182 7.60725C50.6785 7.56854 50.3766 7.52982 50.1879 7.52982C48.7537 7.52982 47.5083 7.95568 46.4893 8.76867C45.8854 9.27196 45.4703 9.77524 45.2061 10.356C45.0174 10.7818 44.8287 11.4012 44.64 12.2142L44.2248 14.1887H39.8469L41.8849 4.31655H46.2628L45.81 6.44583C46.5648 5.59412 47.3196 4.97469 48.0744 4.58755C48.867 4.20041 49.735 4.00684 50.7163 4.00684C51.0937 4.00684 51.4333 4.04555 51.6975 4.08426L51.0182 7.60725Z"
        fill={fills.l}
      />
      <path
        d="M32.3504 14.4997C27.8994 14.4997 25.8575 12.3879 26.7523 8.9374C27.4176 6.37309 29.5284 4.31787 34.117 4.31787C38.2008 4.31787 40.2886 6.05255 39.8527 8.46602H35.1265C35.0347 7.63639 34.5529 7.35356 33.6352 7.35356C32.488 7.35356 31.7997 7.97578 31.4556 9.27679C31.0426 10.8418 31.5703 11.4829 32.7633 11.4829C33.7499 11.4829 34.4152 11.1057 34.8282 10.1818H39.5086C38.8662 12.501 36.503 14.4997 32.3504 14.4997Z"
        fill={fills.l}
      />
      <path
        d="M20.1277 4.31787C24.0765 4.31787 26.2934 6.25996 25.8546 9.29565C25.8085 9.6539 25.7161 9.99329 25.5775 10.3893H16.7792C16.7561 11.4829 17.5875 11.8788 18.6959 11.8788C19.4811 11.8788 20.0584 11.6903 20.4741 11.3509H25.0926C24.2151 13.1987 22.1367 14.4997 18.3495 14.4997C14.3083 14.4997 11.8143 12.4256 12.738 8.88083C13.4308 6.20339 16.0403 4.31787 20.1277 4.31787ZM19.7813 6.91989C18.4188 6.91989 17.726 7.42898 17.3104 8.35289H21.5363C21.6287 7.37242 20.9128 6.91989 19.7813 6.91989Z"
        fill={fills.l}
      />
      <path
        d="M11.5629 7.60725C11.2232 7.56854 10.9213 7.52982 10.7326 7.52982C9.29842 7.52982 8.05297 7.95568 7.03397 8.76867C6.43012 9.27196 6.01497 9.77524 5.75079 10.356C5.56208 10.7818 5.37338 11.4012 5.18468 12.2142L4.76953 14.1887H0.391602L2.4296 4.31655H6.80753L6.35464 6.44583C7.10945 5.59412 7.86427 4.97469 8.61908 4.58755C9.41164 4.20041 10.2797 4.00684 11.2609 4.00684C11.6383 4.00684 11.978 4.04555 12.2422 4.08426L11.5629 7.60725Z"
        fill={fills.r}
      />
    </svg>
  );
};
